import React, { useEffect, useState } from "react";
import {
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  ListGroup,
  ListGroupItem,
  Badge,
} from "reactstrap";
import CardPaymentService from "../../../services/OrderingServices/CardPaymentService";

const statusOptions = [
  { label: "Issued", value: 1, color: "secondary" },
  { label: "Active", value: 2, color: "success" },
  { label: "Suspended", value: 3, color: "warning" },
  { label: "Lost", value: 4, color: "danger" },
  { label: "Damaged", value: 5, color: "dark" },
  { label: "Replaced", value: 6, color: "info" },
  { label: "Expired", value: 7, color: "secondary" },
];

const DetailCard = ({ isOpen, toggle, selectedCard }) => {
  const [detailData, setDetailData] = useState([]);
  const fetchDetailData = async () => {
    try {
      const response = await CardPaymentService.getCardDetail(
        selectedCard?.cardUid,
      );
      setDetailData(response);
    } catch (error) {
      console.error("Error fetching card assign:", error);
    }
  };
  useEffect(() => {
    fetchDetailData();
  }, [selectedCard?.cardUid]);
  return (
    <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
      <OffcanvasHeader toggle={toggle} className="border-bottom">
        Wallet Balance
      </OffcanvasHeader>

      <OffcanvasBody>
        <ListGroup flush>
          <ListGroupItem className="d-flex justify-content-between">
            <strong>Balance</strong>
            <span>{detailData?.balance}</span>
          </ListGroupItem>

          <ListGroupItem className="d-flex justify-content-between">
            <strong>Daily Limit</strong>
            <span>{detailData?.dailyLimit}</span>
          </ListGroupItem>

          <ListGroupItem className="d-flex justify-content-between">
            <strong>Tx Limit</strong>
            <span>{detailData?.txLimit}</span>
          </ListGroupItem>

          <ListGroupItem className="d-flex justify-content-between">
            <strong>Total Recharged</strong>
            <span>{detailData?.totalRecharged}</span>
          </ListGroupItem>

          <ListGroupItem className="d-flex justify-content-between">
            <strong>Total Spent</strong>
            <span>{detailData?.totalSpent}</span>
          </ListGroupItem>
          <ListGroupItem className="d-flex justify-content-between align-items-center">
            <strong>Status</strong>

            {detailData?.status ? (
              (() => {
                const statusObj = statusOptions.find(
                  (s) => s.label === detailData?.status,
                );

                return (
                  <Badge color={statusObj?.color || "secondary"} pill>
                    {statusObj?.label || "Unknown"}
                  </Badge>
                );
              })()
            ) : (
              <Badge color="secondary" pill>
                Unknown
              </Badge>
            )}
          </ListGroupItem>
        </ListGroup>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default DetailCard;
